// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.car-Board {
  display: grid;
  grid-template-columns: 74vw auto;
  gap: 2.5vw;
  margin-top: 2vh;
}
.car-Scene {
  display: grid;
  position: relative;
  place-items: center;
  box-shadow: 0 4px 8px 0 #0003, 0 6px 20px 0 #00000030;
  border: 2px solid #1a6a7c;
}
.car-BackgroundImg {
  width: 100%;
}
.board-loading {
  width: 100%;
  height: 37.5vw;
  display: grid;
  justify-content: center;
  align-items: center;
  background: white;
}

.car-console.run {
  font-family: Consolas;
  height: auto;
  width: auto;
  background: white;
  overflow: auto;
  border: 1px solid #ccc;
  padding: 5px;
}

.car-program-line {
  padding: 2px 5px;
  margin: 1px 0;
  border-left: 3px solid transparent;
}

.car-program-line.current-line {
  background-color: rgb(181, 234, 255);
}

.car-program-line.error-line {
  background-color: rgb(255, 159, 159);
}

.car-console {
  font-family: Consolas;
  max-height: 38vw;
  width: auto;
  border: solid 1px;
  font-size: 1.5vw;
  padding: 10px;
  overflow-y: scroll;
  box-shadow: 0 4px 8px 0 #0003, 0 6px 20px 0 #00000030;
  border-color: rgb(0, 58, 94);
  resize: none;
  color: rgb(0, 58, 94);
}

.car-Management-bar {
  display: grid;
}
.car-platform {
  position: absolute;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.car-A-animal {
  display: grid;
  height: 10vw;
  width: 20vw;
  top: 6vw;
  left: 0;
  grid-template-columns: repeat(3, auto);
}
.car-B-animal {
  display: grid;
  height: 10vw;
  width: 20vw;
  top: 7vw;
  right: 0px;
  grid-template-columns: repeat(3, auto);
  transform: scale(-1, 1);
}
.car-A-family {
  display: grid;
  height: 14.5vw;
  top: 1.5vw;
  left: 0;
  grid-template-columns: repeat(4, auto);
}
.car-B-family {
  display: grid;
  height: 13.5vw;
  top: 6.5vw;
  right: 0;
  grid-template-columns: repeat(4, auto);
  transform: scale(-1, 1);
}
.incarrier-wolf {
  bottom: 7vw;
  width: 7vw;
}
.incarrier-goat {
  display: grid;
  bottom: 7.5vw;
  right: -1vw;
  width: 8.5vw;
}
.incarrier-cabbage {
  display: grid;
  bottom: 7.5vw;
  right: 1.5vw;
  height: 5vw;
}
.incarrier-dad {
  width: 22.7vw;
}
.incarrier-mom {
  width: 22.5vw;
}
.incarrier-boy1 {
  width: 23vw;
}
.incarrier-boy2 {
  width: 23vw;
}
.incarrier-childrens {
  width: 23.4vw;
}
.car-character {
  display: grid;
  position: relative;
}
.car-person-wolf {
  top: 0.4vw;
  width: 7vw;
}

.car-person-goat {
  width: 8.5vw;
}
.car-person-cabbage {
  top: 1.8vw;
  right: 0.5vw;
  width: 5vw;
}
.car-person-mom {
  width: 5.5vw;
}
.car-person-dad {
  width: 5.5vw;
}
.car-person-boy1 {
  width: 5vw;
}
.car-person-boy2 {
  width: 3.5vw;
}
.car-person-momB {
  width: 5.5vw;
}
.car-person-dadB {
  width: 5vw;
}
.car-person-boy1B {
  width: 4vw;
}
.car-person-boy2B {
  width: 3.3vw;
}

#wolfA {
  width: 7vw;
}
#goatA {
  width: 8.5vw;
}
#cabbageA {
  width: 4.6vw;
}
#wolfB {
  width: 8.2vw;
}
#goatB {
  position: relative;
  width: 7.5vw;
  top: 4vw;
  z-index: 1;
}
#cabbageB {
  width: 4.5vw;
}
.person-carrier {
  display: grid;
  position: relative;
  height: 19vw;
}
.carrier-no-animation {
  transition: none !important;
  left: 8%;
}
.person-carrier-family {
  display: grid;
  position: relative;
  height: 10vw;
}
.carrier-family {
  left: 8%;
  position: absolute;
  bottom: 8%;
  will-change: transform;
  backface-visibility: hidden;
}
.carrier-animal {
  top: 36vw;
  left: 8%;
  position: absolute;
  bottom: 4%;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.carrier-left {
  transition: left 4s ease-in-out;
  left: 8%;
}
.carrier-right {
  transition: left 4s ease-in-out;
  left: 54%;
}
.carrier-mirrored {
  transform: scale(-1, 1);
}
#momA {
  width: 5.5vw;
}
#dadA {
  width: 5.5vw;
}
#boy1A {
  position: relative;
  width: 5vw;
}
#boy2A {
  width: 4vw;
  position: relative;
}
#momB {
  width: 5.5vw;
}
#dadB {
  width: 5.5vw;
}
#boy1B {
  position: relative;
  width: 4vw;
  bottom: 3.5vw;
}
#boy2B {
  width: 4vw;
  position: relative;
  bottom: 2.5vw;
}

.car-character-failed.car-person-goat {
  top: 1.8vh;
  animation: fadeIn 0.5s ease-out forwards;
}

.car-character-failed.car-person-cabbage {
  /* капуста */
  top: 0.8vw;
  right: 2.5vw;
  width: 7vw;
  animation: fadeIn 0.5s ease-out forwards;
}

.car-character.fade-in {
  animation: appear 0.5s ease-out forwards;
}

.car-character.fade-out {
  animation: disappear 0.5s ease-in forwards;
}

@keyframes disappear {
  0% {
    opacity: 1;
    transform: scale(1); 
  }
  100% {
    opacity: 0;
    transform: scale(1); 
  }
}
@keyframes appear {
  0% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Carrier/styles/CarBoard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;EACrD,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qDAAqD;EACrD,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,OAAO;EACP,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,UAAU;EACV,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,OAAO;EACP,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,cAAc;EACd,UAAU;EACV,QAAQ;EACR,sCAAsC;EACtC,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,QAAQ;AACV;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,QAAQ;AACV;AACA;EACE,+BAA+B;EAC/B,SAAS;AACX;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".car-Board {\n  display: grid;\n  grid-template-columns: 74vw auto;\n  gap: 2.5vw;\n  margin-top: 2vh;\n}\n.car-Scene {\n  display: grid;\n  position: relative;\n  place-items: center;\n  box-shadow: 0 4px 8px 0 #0003, 0 6px 20px 0 #00000030;\n  border: 2px solid #1a6a7c;\n}\n.car-BackgroundImg {\n  width: 100%;\n}\n.board-loading {\n  width: 100%;\n  height: 37.5vw;\n  display: grid;\n  justify-content: center;\n  align-items: center;\n  background: white;\n}\n\n.car-console.run {\n  font-family: Consolas;\n  height: auto;\n  width: auto;\n  background: white;\n  overflow: auto;\n  border: 1px solid #ccc;\n  padding: 5px;\n}\n\n.car-program-line {\n  padding: 2px 5px;\n  margin: 1px 0;\n  border-left: 3px solid transparent;\n}\n\n.car-program-line.current-line {\n  background-color: rgb(181, 234, 255);\n}\n\n.car-program-line.error-line {\n  background-color: rgb(255, 159, 159);\n}\n\n.car-console {\n  font-family: Consolas;\n  max-height: 38vw;\n  width: auto;\n  border: solid 1px;\n  font-size: 1.5vw;\n  padding: 10px;\n  overflow-y: scroll;\n  box-shadow: 0 4px 8px 0 #0003, 0 6px 20px 0 #00000030;\n  border-color: rgb(0, 58, 94);\n  resize: none;\n  color: rgb(0, 58, 94);\n}\n\n.car-Management-bar {\n  display: grid;\n}\n.car-platform {\n  position: absolute;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n.car-A-animal {\n  display: grid;\n  height: 10vw;\n  width: 20vw;\n  top: 6vw;\n  left: 0;\n  grid-template-columns: repeat(3, auto);\n}\n.car-B-animal {\n  display: grid;\n  height: 10vw;\n  width: 20vw;\n  top: 7vw;\n  right: 0px;\n  grid-template-columns: repeat(3, auto);\n  transform: scale(-1, 1);\n}\n.car-A-family {\n  display: grid;\n  height: 14.5vw;\n  top: 1.5vw;\n  left: 0;\n  grid-template-columns: repeat(4, auto);\n}\n.car-B-family {\n  display: grid;\n  height: 13.5vw;\n  top: 6.5vw;\n  right: 0;\n  grid-template-columns: repeat(4, auto);\n  transform: scale(-1, 1);\n}\n.incarrier-wolf {\n  bottom: 7vw;\n  width: 7vw;\n}\n.incarrier-goat {\n  display: grid;\n  bottom: 7.5vw;\n  right: -1vw;\n  width: 8.5vw;\n}\n.incarrier-cabbage {\n  display: grid;\n  bottom: 7.5vw;\n  right: 1.5vw;\n  height: 5vw;\n}\n.incarrier-dad {\n  width: 22.7vw;\n}\n.incarrier-mom {\n  width: 22.5vw;\n}\n.incarrier-boy1 {\n  width: 23vw;\n}\n.incarrier-boy2 {\n  width: 23vw;\n}\n.incarrier-childrens {\n  width: 23.4vw;\n}\n.car-character {\n  display: grid;\n  position: relative;\n}\n.car-person-wolf {\n  top: 0.4vw;\n  width: 7vw;\n}\n\n.car-person-goat {\n  width: 8.5vw;\n}\n.car-person-cabbage {\n  top: 1.8vw;\n  right: 0.5vw;\n  width: 5vw;\n}\n.car-person-mom {\n  width: 5.5vw;\n}\n.car-person-dad {\n  width: 5.5vw;\n}\n.car-person-boy1 {\n  width: 5vw;\n}\n.car-person-boy2 {\n  width: 3.5vw;\n}\n.car-person-momB {\n  width: 5.5vw;\n}\n.car-person-dadB {\n  width: 5vw;\n}\n.car-person-boy1B {\n  width: 4vw;\n}\n.car-person-boy2B {\n  width: 3.3vw;\n}\n\n#wolfA {\n  width: 7vw;\n}\n#goatA {\n  width: 8.5vw;\n}\n#cabbageA {\n  width: 4.6vw;\n}\n#wolfB {\n  width: 8.2vw;\n}\n#goatB {\n  position: relative;\n  width: 7.5vw;\n  top: 4vw;\n  z-index: 1;\n}\n#cabbageB {\n  width: 4.5vw;\n}\n.person-carrier {\n  display: grid;\n  position: relative;\n  height: 19vw;\n}\n.carrier-no-animation {\n  transition: none !important;\n  left: 8%;\n}\n.person-carrier-family {\n  display: grid;\n  position: relative;\n  height: 10vw;\n}\n.carrier-family {\n  left: 8%;\n  position: absolute;\n  bottom: 8%;\n  will-change: transform;\n  backface-visibility: hidden;\n}\n.carrier-animal {\n  top: 36vw;\n  left: 8%;\n  position: absolute;\n  bottom: 4%;\n  will-change: transform;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n}\n\n.carrier-left {\n  transition: left 4s ease-in-out;\n  left: 8%;\n}\n.carrier-right {\n  transition: left 4s ease-in-out;\n  left: 54%;\n}\n.carrier-mirrored {\n  transform: scale(-1, 1);\n}\n#momA {\n  width: 5.5vw;\n}\n#dadA {\n  width: 5.5vw;\n}\n#boy1A {\n  position: relative;\n  width: 5vw;\n}\n#boy2A {\n  width: 4vw;\n  position: relative;\n}\n#momB {\n  width: 5.5vw;\n}\n#dadB {\n  width: 5.5vw;\n}\n#boy1B {\n  position: relative;\n  width: 4vw;\n  bottom: 3.5vw;\n}\n#boy2B {\n  width: 4vw;\n  position: relative;\n  bottom: 2.5vw;\n}\n\n.car-character-failed.car-person-goat {\n  top: 1.8vh;\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n.car-character-failed.car-person-cabbage {\n  /* капуста */\n  top: 0.8vw;\n  right: 2.5vw;\n  width: 7vw;\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n.car-character.fade-in {\n  animation: appear 0.5s ease-out forwards;\n}\n\n.car-character.fade-out {\n  animation: disappear 0.5s ease-in forwards;\n}\n\n@keyframes disappear {\n  0% {\n    opacity: 1;\n    transform: scale(1); \n  }\n  100% {\n    opacity: 0;\n    transform: scale(1); \n  }\n}\n@keyframes appear {\n  0% {\n    opacity: 0;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
